import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertCircle, X } from 'lucide-react';

interface UnsavedChangesIndicatorProps {
  show: boolean;
  onSave?: () => void;
  onDiscard?: () => void;
  saving?: boolean;
}

export function UnsavedChangesIndicator({
  show,
  onSave,
  onDiscard,
  saving = false
}: UnsavedChangesIndicatorProps) {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 50 }}
          className="fixed bottom-4 left-1/2 transform -translate-x-1/2 z-50"
        >
          <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-4 flex items-center gap-3">
            <AlertCircle className="h-5 w-5 text-amber-500 flex-shrink-0" />
            <span className="text-sm font-medium text-gray-700">
              יש לך שינויים שלא נשמרו
            </span>
            <div className="flex gap-2">
              {onDiscard && (
                <button
                  onClick={onDiscard}
                  disabled={saving}
                  className="px-3 py-1.5 text-sm text-gray-600 hover:text-gray-800 transition-colors disabled:opacity-50"
                >
                  בטל
                </button>
              )}
              {onSave && (
                <button
                  onClick={onSave}
                  disabled={saving}
                  className="px-3 py-1.5 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50 min-w-[60px]"
                >
                  {saving ? 'שומר...' : 'שמור'}
                </button>
              )}
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
